'use client';

import { useState } from 'react';
import Image from 'next/image';
import { useRouter, useSearchParams } from 'next/navigation';

export default function LoginForm() {
    const router = useRouter();
    const searchParams = useSearchParams();

    const redirect = searchParams.get('redirect') || '/';
    const state = searchParams.get('state') || '';

    const [usuario, setUsuario] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setCargando(true);

        try {
            const res = await fetch('/api/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username: usuario,
                    password: contrasena
                })
            });

            const contentType = res.headers.get('content-type') || '';
            let data: any = null;

            if (contentType.includes('application/json')) {
                data = await res.json();
            } else {
                const text = await res.text();
                console.error('Respuesta NO JSON del servidor:', text);
                throw new Error('El servidor respondió con un contenido no JSON. Revisa la consola del servidor.');
            }

            if (!res.ok || !data?.ok) {
                throw new Error(data?.error || 'Usuario o contraseña incorrectos');
            }

            const token = data.token;

            localStorage.setItem('auth_token', token);

            const url = new URL(redirect, window.location.origin);
            url.searchParams.set('token', token);
            if (state) url.searchParams.set('state', state);

            window.location.href = url.toString();
        } catch (err: any) {
            console.error(err);
            setError(err.message || 'Ocurrió un error al iniciar sesión');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="bg-institucional">
            <div className="card-institucional">
                {/* Encabezado */}
                <div className="header-institucional">
                    <div className="logo">
                        <div className="relative w-20 h-20">
                            <Image
                                src="/rostro.png"
                                alt="Universidad Juan José Arévalo Bermejo"
                                fill
                                className="object-contain"
                            />
                        </div>
                    </div>
                    <h2>Universidad Juan José Arévalo Bermejo</h2>
                    <div className="divider"></div>
                </div>

                {/* Cuerpo */}
                <div className="body-institucional">
                    <h1>Iniciar Sesión</h1>
                    <p className="subtitle">Accede a tu cuenta para continuar</p>

                    {error && (
                        <div className="alert alert-error">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-1">
                            <label htmlFor="usuario" className="block text-sm font-medium text-slate-700">
                                Usuario
                            </label>
                            <div className="input-group">
                                <span className="icon">👤</span>
                                <input
                                    id="usuario"
                                    type="text"
                                    placeholder="Ingresa tu usuario"
                                    value={usuario}
                                    onChange={(e) => setUsuario(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="space-y-1">
                            <label htmlFor="contrasena" className="block text-sm font-medium text-slate-700">
                                Contraseña
                            </label>
                            <div className="input-group">
                                <span className="icon">🔒</span>
                                <input
                                    id="contrasena"
                                    type="password"
                                    placeholder="Ingresa tu contraseña"
                                    value={contrasena}
                                    onChange={(e) => setContrasena(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={cargando}
                            className="btn-primary"
                        >
                            {cargando ? 'Ingresando…' : 'Iniciar Sesión'}
                        </button>
                    </form>

                    <div className="mt-4 text-center">
                        <button
                            type="button"
                            className="link-action"
                            onClick={() => router.push('/recuperar-contrasena')}
                        >
                            ¿Olvidaste tu contraseña?
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}